// extracted by mini-css-extract-plugin
module.exports = {"productList":"ProductList_productList___S5Gk","grid":"ProductList_grid__XhK4d"};